// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardCard_container__Q6WWZ","fullHeight":"DashboardCard_fullHeight__iM6Kq"};